export const STATE_KEY = 'CollectTransferRequest'
export const TRANSFER_DATA_KEY = 'transferData'
export const CONFIRMATION_FORM_KEY = 'confirmationForm'
export const FORM_NAME = 'transfer_request_confirmation_form'

export const CONTENT_LOAD = 'Collect/TransferRequest/LOAD'
export const CONTENT_LOAD_SUCCESS = 'Collect/TransferRequest/LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Collect/TransferRequest/LOAD_ERROR'
